<template>
  <div>
    <div v-if="error">
      <div class="error">
        <h1>Ha habido un error cargando la página</h1>
      </div>
    </div>
    <router-view v-if="!loading && !error" />
  </div>
</template>
<script>
import clientsConf from "@/clients";
import Vue from "vue";

export default {
  metaInfo() {
    if (this.loading) return;

    return this.$config.metaInfo(Vue.prototype.$content);
  },
  data() {
    return {
      loading: true,
      error: false
    };
  },
  mounted() {
    // Detectar si estamos en localhost o test.erescambio.com
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const isTestErescambio = window.location.hostname === 'test.erescambio.com';

    const urlParams = new URLSearchParams(window.location.search);
    const pathname = window.location.pathname;

    let url;

    if (isLocalhost) {
      // EN LOCALHOST:
      // 1. Primero buscar parámetro ?web= en la URL (puede incluir path)
      // 2. Si no existe, usar VUE_APP_OVERRIDE_URL + path actual
      if (urlParams.has('web')) {
        url = urlParams.get('web'); // Puede ser "domain.com/hola"
      } else if (process.env.VUE_APP_OVERRIDE_URL) {
        url = process.env.VUE_APP_OVERRIDE_URL + pathname;
      } else {
        // Fallback si no hay ninguno configurado
        url = window.location.hostname + pathname;
      }
    } else if (isTestErescambio) {
      // EN TEST.ERESCAMBIO.COM:
      // 1. Primero buscar parámetro ?web= en la URL (puede incluir path)
      // 2. Si no existe, usar el hostname actual + path actual
      if (urlParams.has('web')) {
        url = urlParams.get('web'); // Puede ser "domain.com/hola"
      } else {
        url = window.location.hostname + pathname;
      }
    } else {
      // EN PRODUCCIÓN (www.erescambio.com u otros):
      // Siempre setear el parámetro web a window.location.hostname + pathname
      url = window.location.hostname + pathname;
    }

    if (urlParams.has('i')) {
      url += '&i=' + urlParams.get('i');
    }

    var urlsLegales = [
      "/nota-legal",
      "/politica-de-privacidad",
      "/politica-de-cookies",
      "/declaracion-de-accesibilidad",
    ];

    // Cargar datos únicamente desde la API
    clientsConf[process.env.VUE_APP_CLIENT].getWeb(url)
      .then((d) => {
        const content = d.data;

        if (!content) {
          this.error = true;
          return;
        }

        if (urlsLegales.includes(pathname)) {
          content.individual = true;
          content.post_type = pathname.replace("/", "");
        }

        Vue.prototype.$content = content;
        this.loading = false;
        if (document.getElementById('initial-loader')) {
          document.getElementById('initial-loader').style.display = 'none';
        }
      })
      .catch(() => {
        this.error = true;
      });
  },
};
</script>

<style>


.error {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 9999;
  text-align: center;
}
</style>
